import { FormProvider, UseFormReturn } from 'react-hook-form'
import FormFieldFromProps from '@Fields/v2/FormFieldFromProps'
import IdentifiersSection from '@Scenes/RightsholderRegistrationLayout/RightsholderRegistrationForm/IdentifiersSection'
import Button from '@Components/Buttons/Button'
import { ICONS } from '@Const/common'
import React from 'react'
import { createSongwriterFormFields } from '@Entities/schemas/songwriter/create-songwriter'
import { CreateSongwriterPayload } from '@Entities/songwriter/create-songwriter-payload'
import CheckboxForm from '@Fields/v2/CheckboxForm'
import FormFieldProps from '@App/forms/v2/common/form-field'

interface SongwriterRegistrationFormProps {
    methods: UseFormReturn<{ name: string; ipiNumber?: string | undefined; termsAndConditions: boolean }, any>
    onSubmit(data: CreateSongwriterPayload): void
}

const SongwriterRegistrationForm = (props: SongwriterRegistrationFormProps) => {
    const { methods, onSubmit } = props
    const { name, ipiNumber, termsAndConditions } = createSongwriterFormFields

    return (
        <div className="songwriter-inputs">
            <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(onSubmit)}>
                    <FormFieldFromProps field={name} />
                    <IdentifiersSection ipiNumber={ipiNumber} />
                    <CheckboxForm {...(termsAndConditions as FormFieldProps)}>
                        <>
                            <a
                                href="https://www.themlc.com/songwriter-hub-terms-of-use"
                                target="_blank"
                                className="small"
                                rel="noreferrer"
                            >
                                Terms of Use
                            </a>{' '}
                            <strong className="blue-text">Required</strong>
                        </>
                    </CheckboxForm>
                    <Button type="primary" icon={ICONS.arrow_forward} mainColor submitType="submit">
                        Next
                    </Button>
                </form>
            </FormProvider>
        </div>
    )
}
export default SongwriterRegistrationForm
